import TTSStatus from "./TTSStatus";

function getBase(state) {
  return state.tts;
}

export function getVoices(state) {
  return getBase(state).voices;
}

export function getCurrentVoiceIndex(state) {
  return getBase(state).voiceIndex;
}

export function getCurrentRate(state) {
  return getBase(state).rate;
}

export function getVoiceName(state) {
  // get the voice stored in state. This may have been stored
  // from a different set of voices on a different browser/platform
  return getBase(state).voiceName;
}

export function getVoiceLang(state) {
  // get the voice lang stored in state. This will help getting a
  // better match if voice is from a different browser/platform
  return getBase(state).voiceLang;
}

export function getCurrentVoiceName(state) {
  // get the name of the current voice by index in the current set of voices
  const currentVoiceIndex = getCurrentVoiceIndex(state);
  return getVoices(state)?.[currentVoiceIndex]?.name;
}

export function getStatus(state) {
  const { playing, paused } = getBase(state).playbackStatus;
  if (paused) {
    return TTSStatus.PAUSED;
  }
  if (playing) {
    return TTSStatus.PLAYING;
  }
  return TTSStatus.STOPPED;
}

export function isAltEnabled(state) {
  return getBase(state).altEnabled;
}

export function isSimplifiedReadingEnabled(state) {
  return getBase(state).simplifiedReadingEnabled;
}

export function getDecentered(state): boolean {
  return getBase(state).decentered;
}
